module.exports = __webpack_public_path__ + "img/nato.7d2d4955.svg";